var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 22C6.47798 22 2.00098 17.523 2.00098 12C2.00098 6.477 6.47798 2 12.001 2C17.5241 2 22.001 6.477 22.001 12C22.001 17.523 17.5241 22 12.001 22ZM12.001 19.9999C14.1227 19.9999 16.1576 19.1571 17.6579 17.6568C19.1582 16.1566 20.001 14.1217 20.001 12C20.001 9.87827 19.1582 7.84344 17.6579 6.34314C16.1576 4.84286 14.1227 4.00001 12.001 4.00001C9.87925 4.00001 7.84442 4.84286 6.34412 6.34314C4.84384 7.84344 4.00099 9.87827 4.00099 12C4.00099 14.1217 4.84384 16.1566 6.34412 17.6568C7.84442 19.1571 9.87925 19.9999 12.001 19.9999ZM13.001 12H17.001V14H11.001V7.00001H13.001V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock-2.f90b94401ffc4f7c4e3fe6ce653bebb3.svg";
export { ForwardRef as ReactComponent };